<template>
  <div class="activities">
    <b-container style="margin:0px auto;">
      <b-row>
        <b-col>
          <h1 style="margin-top:1%;">各校OA活動</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
            <div class="tb">
    <b-table responsive :items="items" :fields="fields">
      <template v-slot:cell(活動名稱)="data">
        <span v-html="data.value">
          </span>
      </template>
      <template v-slot:cell(主辦單位)="data1">
        <span v-html="data1.value"></span>
      </template>
      <template v-slot:cell(活動時間)="data2">
        <span v-html="data2.value"></span>
      </template>
    </b-table>
    </div>
        </b-col>
      </b-row>
    </b-container>
    </div>
</template>
<script>
// import { mdbBtn, mdbContainer, mdbCol, mdbRow, mdbCard, mdbCardBody } from 'mdbvue'
// import 'vue-good-table/dist/vue-good-table.css'
// import { VueGoodTable } from 'vue-good-table';
export default {
  name: 'Links',
  components: {
    // VueGoodTable,
    // VueVirtualTable
    // mdbBtn,
    // mdbContainer,
    // mdbCol,
    // mdbRow,
    // mdbCard,
    // mdbCardBody
  },
  data () {
    return {
      showCollapse: true,
      collapse2: false,
      collapse3: false,
      // columns:[
      //   {
      //     label:"活動名稱",
      //     field:"name",
      //   },
      //   {
      //     label:"活動時間",
      //     field:"time",
      //     type:"date",
      //   },
      //   {
      //     label:"主辦單位",
      //     field:"host",
      //   }
      // ],
      // rows:[
      //   {id:1, name:'2019開放取用週：為誰開放？公平的開放知識', time:'2019/10/21-27', host:'ntnu'},
      // ]
      // ,
      fields:[
        {
          key:'ID',
          sortable: false
        },
        {
          key:'活動名稱',
          sortable: false
        },{
          key:'活動時間',
          sortable: true
        },{
          key:'主辦單位',
          sortable: false
        }
      ],
      items:[
        {
          ID:1,
          活動名稱:'<a href="https://subjectguide.lib.ntnu.edu.tw/2019OAweek">2019開放取用週：為誰開放？公平的開放知識</a>',
          活動時間:'2019/10/21-27',
          主辦單位:'國立臺灣師範大學圖書館'
          },
        {
          ID:2,
          活動名稱:'<a href="https://secure.wiley.com/CTW_Uniday">OA期刊投稿與防範掠奪期刊講座「我們與假期刊的距離」</a>',
          活動時間:'2019/10/22',
          主辦單位:'國立中興大學圖書館'
          },
        {
          ID:3,
          活動名稱:'<a href="http://www.lib.ncku.edu.tw/news/news_show_ch_news.php?news_id=4530">開放取用週 OA Week活動</a>',
          活動時間:'2019/10/18-27',
          主辦單位:'國立成功大學圖書館'
        },
        {
          ID:4,
          活動名稱:'<a href="http://library.tmu.edu.tw/events/2019OA">2019 國際OA週活動線上有獎徵答</a>',
          活動時間:'2019/10/21-25',
          主辦單位:'臺北醫學大學圖書館'
        },
        {
          ID:5,
          活動名稱:'<a href="http://ma.wzu.edu.tw/files/303-1000-3750,c11.php">認識OA與掠奪性期刊</a>',
          活動時間:'2019/10/30',
          主辦單位:'文藻外語大學圖書館'
        },
        {
          ID:6,
          活動名稱:'<a href="http://li.csu.edu.tw/wSite/csu/ActivitySign/csuActivityDetail.jsp?activityID=257221&ctNode=8057&mp=1">如何避開投稿陷阱專題講座-預防勝於被掠奪，研究心血不白流</a>',
          活動時間:'2019/11/14',
          主辦單位:'正修科技大學圖書資訊處'
        },
        {
          ID:7,
          活動名稱:'<a href=" http://lib.cnu.edu.tw/3_4_extension/lib_week/201912/act1.htm">認識掠奪性期刊/避開投稿陷阱 研習活動</a>',
          活動時間:'2019/12/10',
          主辦單位:'嘉南藥理大學圖書資訊館(讀者服務組)'
        },
        {
          ID:8,
          活動名稱:'<a href=" https://nchulib123.wixsite.com/oaweek2019">2019 OA Week 有獎徵答</a>',
          活動時間:'2019/12/2-6',
          主辦單位:'國立中興大學圖書館'
        },
        {
          ID:9,
          活動名稱:'<a href=" http://library.asia.edu.tw/files/13-1037-75436.php?Lang=zh-tw">現場 OA Bingo 連線</a>',
          活動時間:'2019/12/2-6',
          主辦單位:'亞洲大學圖書館'
        },
        {
          ID:10,
          活動名稱:'<a href="http://tul.blog.ntu.edu.tw/archives/22038#more-22038">參考服務部落格－學術投稿專題（OA、掠奪型期刊、Master講堂）</a>',
          活動時間:'2019/1/1-12/31',
          主辦單位:'國立臺灣大學圖書館'
        },
        {
          ID:11,
          活動名稱:'<a href="https://drive.google.com/file/d/17M0ufWAw-KG_p6jQG2wftCjbhpwIOcSW/view?usp=sharing">前進系所活動－學科館員至系所務會議宣導（學術詐騙、學術典藏）</a>',
          活動時間:'2019/3/1-10/31',
          主辦單位:'國立臺灣大學圖書館'
        }
      ]
    }
  },
  methods: {
    beforeEnter (el) {
      this.elHeight = el.scrollHeight
    },
    enter (el) {
      el.style.height = this.elHeight + 'px'
    },
    beforeLeave (el) {
      el.style.height = 0
    }
  }
}

</script>
<style scoped>
.collapse-item {
  overflow: hidden;
  height: 0;
  padding: 0;
  transition: height .5s;
}
/*#collapse-1{
  position: relative;
  height: 0;
  overflow: show;
  @include transition($transition-collapse);
}*/
span {
  font-family: Microsoft JhengHei;
  font-size: 16px;
  font-weight: bold;
}
.activities {
  padding-top: 20px;
  background-color: rgba(248, 194, 88,0.1);
  box-shadow: 0 5px 5px -2px rgba(0, 0, 0, .2);
  padding-bottom:400px;
}
.tb {
   margin-top: 3%;
    /* margin-left:5%;
    margin-right:5%;  */
    background-color:white 0.5;
    border-radius:10px;
    box-shadow:0 0 5px #000;
    width:100%;
    }
/*.contain {

  padding-bottom:20px;
  background-color: rgba(0, 137, 184, 0.15);
  box-shadow: 0 5px 5px -2px rgba(0,0,0,.2);
}
.contain1 {
  padding-bottom:10px;
  background-color: rgba(193,66,66,0.3);
  box-shadow: 0 5px 5px -2px rgba(0,0,0,.2);
}
.contain2 {
  padding-bottom:10px;
  background-color: rgba(191,191,63,0.18);
  box-shadow: 0 5px 5px -2px rgba(0,0,0,.2);
}
.contain3 {
  padding-bottom:10px;
  background-color: rgba(63,63,191,0.1);
  box-shadow: 0 5px 5px -2px rgba(0,0,0,.2);
}*/
</style>
